module.exports = __webpack_public_path__ + "static/media/superiorClothes.1cf87754.jpeg";